import React, { useState } from "react";
import {
  Button,
  Col,
  FormGroup,
  Input,
  InputGroup,
  InputGroupText,
  Label,
} from "reactstrap";
import classnames from "classnames";

export type FolderFormProps = {
  handleSubmitForm?: (folderName: string) => void;
  handleCloseForm?: () => void;
};

const FolderForm = ({ handleSubmitForm, handleCloseForm }: FolderFormProps) => {
  const [folderName, setFolderName] = useState("");
  const [submitDisabled, setSubmitDisabled] = useState(true);

  const onChangeFormInputHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setFolderName(value);
    setSubmitDisabled(value.trim().length === 0);
  };

  const onSubmit = () => {
    handleSubmitForm?.(folderName);
    setFolderName("");
    setSubmitDisabled(true);
  };

  return (
    <FormGroup className="row justify-content-center">
      <Label
        className="form-control-label"
        htmlFor="example-text-input"
        md="2"
        style={{
          marginRight: "-100px",
          paddingRight: "0px",
          paddingLeft: "0px",
        }}
      >
        Add Folder
      </Label>

      <Col md="4">
        <InputGroup
          className={classnames("input-group-merge", { focused: folderName })}
        >
          <InputGroupText>
            <i className="ni ni-folder-17 text-primary" />
          </InputGroupText>
          <Input
            placeholder="Insert folder name"
            type="text"
            value={folderName}
            onChange={onChangeFormInputHandler}
            required
          />
        </InputGroup>
      </Col>

      <Col md="2" style={{ maxWidth: "70px" }}>
        <Button
          color="primary"
          type="button"
          size="lg"
          className="btn justify-content-center"
          onClick={onSubmit}
          disabled={submitDisabled}
        >
          OK
        </Button>
      </Col>

      <Col md="2">
        <Button
          color="danger"
          type="button"
          size="lg"
          className="btn justify-content-center"
          onClick={handleCloseForm}
        >
          Close
        </Button>
      </Col>
    </FormGroup>
  );
};

export default FolderForm;
